import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Badge } from '../components/ui/badge';
import { Store, Star, Users, ArrowRight } from 'lucide-react';

const Marketplace = () => {
  const vendors = [
    { name: 'LegalZoom Partners', category: 'Legal Services', rating: 4.8, reviews: 234, featured: true },
    { name: 'QuickBooks Pro', category: 'Accounting', rating: 4.9, reviews: 567, featured: true },
    { name: 'HubSpot CRM', category: 'Marketing', rating: 4.7, reviews: 432, featured: false },
    { name: 'Gusto Payroll', category: 'HR & Payroll', rating: 4.6, reviews: 321, featured: false },
    { name: 'Stripe Payments', category: 'Payment Processing', rating: 4.9, reviews: 876, featured: true },
    { name: 'Mailchimp', category: 'Email Marketing', rating: 4.5, reviews: 654, featured: false },
  ];

  return (
    <div className="min-h-screen bg-slate-50 p-6">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="flex items-center justify-between mb-8">
          <div>
            <h1 className="text-3xl font-bold text-slate-800 mb-2">Marketplace</h1>
            <p className="text-slate-600">Discover trusted vendors and integrations for your business</p>
          </div>
          <Button variant="outline">Become a Vendor</Button>
        </div>

        {/* Vendors Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {vendors.map((vendor, idx) => (
            <Card key={idx} className="border-0 shadow-lg hover:shadow-xl transition-shadow cursor-pointer">
              <CardContent className="p-6">
                <div className="flex items-start justify-between mb-4">
                  <div className="w-12 h-12 bg-gradient-to-br from-purple-100 to-teal-100 rounded-xl flex items-center justify-center">
                    <Store className="w-6 h-6 text-purple-600" />
                  </div>
                  {vendor.featured && (
                    <Badge className="bg-gradient-to-r from-purple-500 to-teal-500 text-white">Featured</Badge>
                  )}
                </div>
                <h3 className="text-lg font-semibold text-slate-800 mb-1">{vendor.name}</h3>
                <p className="text-sm text-slate-500 mb-4">{vendor.category}</p>
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    <Star className="w-4 h-4 text-amber-400 fill-amber-400" />
                    <span className="font-medium">{vendor.rating}</span>
                    <span className="text-slate-400 text-sm">({vendor.reviews})</span>
                  </div>
                  <Button variant="ghost" size="sm" className="text-purple-600">
                    View <ArrowRight className="w-4 h-4 ml-1" />
                  </Button>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Marketplace;
